// src/components/Logout.js
import React from 'react';
import userManager from '../auth/UserManager';

const Logout = () => {
    const handleLogout = () => {
        userManager.signoutRedirect();
    };

    return (
        <div>
            <h2>Logout</h2>
            <button onClick={handleLogout}>Logout</button>
        </div>
    );
};

export default Logout;
